import React, { useState, useRef, useEffect } from 'react';
import { IoIosHelpCircleOutline } from 'react-icons/io';

export default function EventHelpTooltip({ title, body }) {
  const [open, setOpen] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', closeOnOutsideClick);
    } else {
      document.removeEventListener('mousedown', closeOnOutsideClick);
    }
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [open]);

  return (
    <div style={styles.container} ref={tooltipRef}>
 <button style={styles.iconBtn} onClick={() => setOpen((prev) => !prev)}>
  <IoIosHelpCircleOutline 
    style={{ width: 20, height: 20, flexShrink: 0 }} 
    color="#555" 
  />
</button>


      {open && (
        <div style={styles.tooltip}>
          <div style={styles.tooltipTitle}>{title}</div>
          <div style={styles.tooltipBody}>{body}</div>
          <div style={styles.pointer}></div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    display: 'inline-block',
  },
  iconBtn: {
    border: 'none',
    background: '#f0f0f0',
    borderRadius: '50%',
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  tooltip: {
    position: 'absolute',
    top: 'calc(100% + 10px)',
    right: 4,
    width: 220,
    backgroundColor: '#000',
    color: '#fff',
    padding: '10px 12px',
    borderRadius: 8,
    fontSize: 12,
    zIndex: 9999,
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
  tooltipTitle: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  tooltipBody: {
    lineHeight: 1.4,
  },
  pointer: {
    position: 'absolute',
    top: '-6px',
    borderRadius: 4,
    right: '0px',
    width: '16px',
    height: '16px',
    backgroundColor: '#000',
    clipPath: 'path("M 20 20 Q 8 20 6 12 Q 4 4 0 0 L 20 0 Z")',
    transform: 'rotate(90deg)',

},
  
};
